// import React from "react";
import React from 'react';
import { Award, Users, Target, CheckCircle, Eye, Check, Clock, Building2, Landmark, MapPin } from "lucide-react";
import Footer from "../components/Footer";
import OurTeam from "../components/OurTeam"

const AboutPage = () => {
  const stats = [
    {
      title: "Experience",
      label: "24+ years in structural design and project execution.",
      icon: <Building2 size={36} />,
    },
    {
      title: "Client Approach",
      label: "Engineering solutions tailored to project needs.",
      icon: <Award size={36} />,
    },
    {
      title: "Quality Assurance",
      label: "compliant, safe, and reliable structural designs.",
      icon: <Landmark size={36} />,
    },
    {
      title: "Integrity",
      label: "Ethical engineering with transparency and accountability.",
      icon: <MapPin size={36} />,
    },
  ];


  const values = [
    {
      icon: Target,
      title: "Quality First",
      description:
        "We never compromise on quality. Every project reflects our commitment to excellence and precision in construction.",
    },
    {
      icon: CheckCircle,
      title: "Timely Delivery",
      description:
        "We understand the value of time and ensure all projects are completed within the agreed timeline.",
    },
    {
      icon: Users,
      title: "Customer Focus",
      description:
        "Our clients are at the heart of everything we do. We listen, understand, and deliver beyond expectations.",
    },
    {
      icon: Award,
      title: "Innovation",
      description:
        "We embrace modern construction techniques and technologies to provide innovative solutions.",
    },
  ];

  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Hero Section */}
      <section
        className="relative flex items-center justify-center text-white overflow-hidden"
        style={{
          backgroundImage: "url('/images/360_F_914684393_H1BpbfpdBgzVUYyKseFYVC5Ziu1KC3ks.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="absolute inset-0 bg-black/60"></div>

        <div className="relative z-10 max-w-7xl px-4 sm:px-8 md:px-16 lg:px-20 text-center py-24 md:py-32 lg:py-40">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-bold leading-tight mb-6">
            <span className="bg-white bg-clip-text text-transparent drop-shadow-lg">
              About Us
            </span>
          </h1>

          <p className="text-base sm:text-lg md:text-xl text-gray-100 max-w-3xl mx-auto leading-relaxed">
            We are a trusted name in engineering and construction, delivering innovative,
            safe, and sustainable infrastructure solutions.
          </p>

        </div>
      </section>



      {/* Leadership Section */}
      <section className="relative py-20 bg-gradient-to-r from-[#e0f2fe] via-white to-[#e0f2fe] overflow-hidden">
        {/* Optional floating blob */}
        <div className="absolute top-0 right-0 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob animation-delay-2000 -z-10"></div>
        <div className="absolute bottom-0 left-0 w-72 h-72 bg-indigo-200 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-blob -z-10"></div>

        <div className="max-w-7xl mx-auto px-6 lg:px-8 2xl:max-w-8xl min-h-screen">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-[#011321] mb-4">Leadership Excellence</h2>
            {/* <div className="w-20 h-[2px] bg-gray-300 mx-auto mb-4 mt-6"></div> */}
            <span className="block w-24 sm:w-32 md:w-40 h-0.5 sm:h-1 mx-auto lg:mx-auto bg-gradient-to-r from-yellow-500 via-yellow-300 to-white rounded-full mt-4 sm:mt-6 mb-4"></span>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              Meet the visionary driving our company’s success
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center text-justify">

            {/* Text */}
            <div className="animate-fade-in-left order-2 lg:order-1">
              <h3 className="text-lg  sm:text-2xl font-bold text-gray-900 mb-2">
                Mr. Aman Kumar Singh
              </h3>
              <p className="text-[#234683] font-semibold mb-6 text-sm sm:text-lg">
                Director | M. Tech (Structural Engineering)
              </p>

              <p className="text-gray-700 text-sm sm:text-lg mb-4">
                <strong>Mr. Aman Kumar Singh</strong> Director, Co-Founder
                of AAJ Engineers, is a postgraduate Structural Engineer with
                over 24 years of experience in delivering safe, efficient, and
                future ready structural solutions. Since founding the firm in 2002,
                he has guided the successful completion of <strong>3,000+ projects across India, </strong>
                spanning residential, commercial, industrial, and government sectors.
              </p>

              <p className="text-gray-700 text-sm sm:text-lg mb-4">
                Driven by a vision to create <strong>structurally sound, economical, and
                  code compliant designs,</strong> Mr. Singh leads AAJ Engineers with a strong
                focus on  <strong>engineering precision, innovation, and long term performance.</strong>
                His approach integrates advanced structural analysis, strict adherence
                to IS Codes, and the Limit State Method to ensure every project balances
                <strong> safety, durability, and cost efficiency.</strong>
              </p>
              <p className="text-gray-700 text-sm sm:text-lg ">
                Actively involved from concept to execution, he remains committed to building structures that stand the test of time while delivering value, reliability, and trust to clients.
              </p>
            </div>

            {/* Image */}
            <div className="flex justify-center lg:justify-end animate-fade-in-right order-1 lg:order-2">
              <div className="relative group">
                <img
                  src="/team/Mr.Aman-Kumar.jpg"
                  alt="Leadership"
                  className="w-full max-w-md rounded-2xl object-cover shadow-xl transition-transform duration-500 hover:scale-105 hover:shadow-2xl"
                />
                <div className="absolute -bottom-4 -left-4 bg-gradient-to-r from-[#234683] to-[#011321] text-white px-4 py-2 rounded-xl shadow-lg text-sm font-semibold">
                  24+ Years Experience
                </div>
              </div>
            </div>

          </div>


          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center text-justify mt-24">

            {/* Image */}
            <div className="flex justify-center lg:justify-start animate-fade-in-right order-1">
              <div className="relative group">
                <img
                  src="/team/Mr-Ashish-Shiwarkar-Webphoto.jpg"
                  alt="Leadership"
                  className="w-full max-w-md rounded-2xl object-cover shadow-xl transition-transform duration-500 hover:scale-105 hover:shadow-2xl"
                />
                <div className="absolute -bottom-4 -left-4 bg-gradient-to-r from-[#234683] to-[#011321] text-white px-4 py-2 rounded-xl shadow-lg text-sm font-semibold">
                  24+ Years Experience
                </div>
              </div>
            </div>

            {/* Text */}
            <div className="animate-fade-in-left order-2">
              <h3 className="text-lg  sm:text-2xl font-bold text-gray-900 mb-2">
                Mr. Ashish Shiwarkar
              </h3>
              <p className="text-[#234683] font-semibold mb-6 text-sm sm:text-lg">
                Director | M. Tech (Structural Engineering)
              </p>

              <p className="text-gray-700 text-sm sm:text-lg mb-4">
                <strong> Mr. Ashish Shiwarkar</strong>, Co-Founder
                and Director of AAJ Engineers, brings over 24 years
                of leadership in structural engineering, having guided
                the planning and detailing of 3,000+ projects across India.
                His work spans government, residential, commercial, and industrial developments.
              </p>

              <p className="text-gray-700 text-sm sm:text-lg mb-4">
                Driven by a vision to deliver <strong> safe, efficient,
                  and intelligently engineered structures,</strong> he leads
                the firm’s advanced 3D structural analysis and design processes
                optimizing seismic, wind, and dynamic force responses while maintaining cost efficiency.
              </p>
              <p className="text-gray-700 text-sm sm:text-lg  ">
                Known for his precision and strong on site presence,
                Mr. Shiwarkar ensures seamless collaboration between
                clients, consultants, and execution teams turning complex
                designs into dependable, build ready outcomes.</p>

            </div>

          </div>



        </div>

      </section>

      <OurTeam />

      <section className="relative bg-gray-50 py-20" >
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-[#011321] mb-4">Why Choose Us</h2>
            <span className="block w-24 sm:w-32 md:w-40 h-0.5 sm:h-1 mx-auto lg:mx-auto bg-gradient-to-r from-yellow-500 via-yellow-300 to-white rounded-full mt-4 sm:mt-6 mb-4"></span>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              What makes us the right partner.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10 ">
            {stats.map((item, index) => (
              <div
                key={index}
                className="relative flex flex-col items-center p-6 bg-white rounded-3xl shadow-xl hover:shadow-2xl transition-transform transform hover:-translate-y-2 border-8 border-gray-200"
              >
                {/* Icon */}
                <div className="absolute -top-6 w-16 h-16 bg-gray-800 text-white rounded-full flex items-center justify-center text-3xl shadow-lg">
                  {item.icon}
                </div>
                <div className="mt-12 text-center">
                  {/* Title */}
                  <span className="text-xl md:text-xl font-extrabold text-[#011321]">
                    {item.title}
                  </span>

                  {/* Label */}
                  <p className="mt-2 text-gray-600 text-sm md:text-base font-medium">
                    {item.label}
                  </p>
                </div>
              </div>
            ))}
          </div>

        </div>
      </section>

      <style>
        {`
  .animate-blob {
    animation: blob 7s infinite;
  }
  .animation-delay-2000 {
    animation-delay: 2s;
  }
  @keyframes blob {
    0% { transform: translate(0px, 0px) scale(1); }
    33% { transform: translate(30px, -50px) scale(1.1); }
    66% { transform: translate(-20px, 20px) scale(0.9); }
    100% { transform: translate(0px, 0px) scale(1); }
  }
`}
      </style>

      {/* <section className="py-24 bg-gradient-to-r from-[#1e3c72] to-[#2a5298] text-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 md:grid-cols-2 gap-16 items-start">
         
          <div className="space-y-10">
           
            <div className="p-8 bg-white/10 rounded-3xl shadow-xl hover:bg-white/20 transition duration-300">
              <h3 className="text-3xl font-bold mb-4 flex items-center gap-3">
                <Eye className="w-8 h-8 text-yellow-400" /> Vision
              </h3>
              <p className="text-gray-200 leading-relaxed text-lg">
                To be recognized as one of the top construction organizations, setting benchmarks in quality, trust, and innovation.
              </p>
            </div>

           
            <div className="p-8 bg-white/10 rounded-3xl shadow-xl hover:bg-white/20 transition duration-300">
              <h3 className="text-3xl font-bold mb-4 flex items-center gap-3">
                <Target className="w-8 h-8 text-yellow-400" /> Mission
              </h3>
              <p className="text-gray-200 leading-relaxed text-lg">
                To maintain trust and loyalty with our clients by delivering high-quality ServicesPage at affordable prices through our qualified team.
              </p>
            </div>
          </div>

         
          <div className="flex flex-wrap justify-center md:justify-end gap-6">
            <img
              src="/images/d3c4736c-73ad-4eca-81ae-2b81035df543.jpg"
              alt="Mission Vision Illustration"
              className="w-80 sm:w-96 md:w-96 lg:w-[400px] rounded-3xl shadow-2xl hover:scale-105 transition-transform duration-500"
            />

          </div>
        </div>
      </section> */}

      {/* Values Section */}
      <section className="py-16 bg-gray-300">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-[#011321] mb-4">Our Values</h2>
            {/* <div className="w-20 h-[2px] bg-gray-300 mx-auto mb-4 mt-6"></div> */}
            <span className="block w-24 sm:w-32 md:w-40 h-0.5 sm:h-1 mx-auto lg:mx-auto bg-gradient-to-r from-yellow-500 via-yellow-300 to-white rounded-full mt-4 sm:mt-6 mb-4"></span>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto leading-relaxed">
              These core values guide every decision we make and every project
              we undertake.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div
                  key={index}
                  className="flex items-start gap-4 p-6 bg-white rounded-xl shadow-md hover:shadow-xl transition border-8"
                >
                  <div className="w-12 h-12 bg-gray-100 rounded-md flex items-center justify-center">
                    <Icon className="w-6 h-6 text-gray-800" />
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">
                      {value.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {value.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default AboutPage;